import PageContent from "../../../app/layouts/PageContent";
import useOrganization from "../../organization/hooks/useOrganization";
import UserManagementAccordion from "../components/UserManagementAccordion";

const UserManagementPage = () => {
  const { currentOrganization } = useOrganization();

  return (
    <PageContent>
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-6">User Management</h2>

        {currentOrganization?.id && <UserManagementAccordion />}
      </div>
    </PageContent>
  );
};

export default UserManagementPage;
